
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Resortinnagpurdistrictwithoutdoor() {



  const cardData =
  {
    keyword: ' Resort in Nagpur District with Outdoor Activities',
    heading:  'Woodland Escape: Resort in Nagpur District with Outdoor Activities ',
    headingDescription: 'Woodland Escape Resort is an excellent resort in Nagpur District with outdoor activities, offering an ideal mix of nature and adventure for your getaway. Nestled amidst forest-fringed lawns and open green spaces, it provides ample opportunities for outdoor fun — think nature trails, open-air games on the lawn, shaded tree-clusters for relaxing, and scenic spots perfect for group activities or casual team outings. With comfortable cottages, friendly hospitality, and well-maintained grounds, Woodland Escape Resort near Nagpur ensures your stay is both engaging and rejuvenating in the heart of nature.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Resort in Nagpur District with Outdoor Activities",
      "description": "Experience a perfect blend of relaxation and adventure at this resort in Nagpur district, offering a wide range of outdoor activities for all age groups. From nature trails and riverside walks to team-building games and adventure sports, this resort caters to families, couples, and friends looking for an active and memorable stay. Enjoy eco-friendly accommodations, scenic views, and expertly curated outdoor programs."
    },
    {
      "name": "Nagpur Adventure Resort",
      "description": "Nagpur Adventure Resort offers an action-packed experience with activities like trekking, rock climbing, zip-lining, and obstacle courses. Nestled in lush greenery, it is ideal for adventure enthusiasts and families who want to combine comfort with thrilling outdoor fun."
    },
    {
      "name": "Nagpur Nature Activities Resort",
      "description": "Reconnect with nature at Nagpur Nature Activities Resort. Guests can enjoy guided forest walks, bird watching, camping, and eco-friendly workshops. The resort focuses on providing immersive experiences in the natural surroundings while maintaining comfort and sustainability."
    },
    {
      "name": "Nagpur Family Activity Resort",
      "description": "Nagpur Family Activity Resort is designed for families seeking both fun and relaxation. Activities include cycling, nature trails, playgrounds for kids, and group games for all ages. The resort also offers spacious family-friendly accommodations and organic dining options."
    },
    {
      "name": "Nagpur Kids Friendly Activity Resort",
      "description": "Perfect for families with children, this resort features kid-friendly outdoor activities like scavenger hunts, adventure playgrounds, and nature trails. Safety and engagement are prioritized, making it a fun and educational experience for young guests."
    },
    {
      "name": "Nagpur Jungle Adventure Resort",
      "description": "Set amidst dense forests, Nagpur Jungle Adventure Resort offers a unique jungle experience with guided wildlife tours, trekking, river rafting, and camping. Guests can explore nature while staying in eco-friendly accommodations that blend with the surroundings."
    },
    {
      "name": "Nagpur Riverside Outdoor Resort",
      "description": "Enjoy a serene riverside experience at Nagpur Riverside Outdoor Resort. Guests can participate in kayaking, fishing, riverside picnics, and nature walks. The resort combines relaxation with outdoor fun, making it perfect for couples, families, and groups."
    },
    {
      "name": "Nagpur Hill Activity Resort",
      "description": "Nagpur Hill Activity Resort is set on scenic hills and offers adventure activities like hiking, rock climbing, and outdoor yoga. With panoramic views, eco-friendly cottages, and guided hill treks, it’s ideal for nature lovers and adventure seekers."
    },
    {
      "name": "Nagpur Luxury Activity Resort",
      "description": "Nagpur Luxury Activity Resort combines upscale comfort with outdoor excitement. Guests can enjoy private villas, infinity pools, adventure sports, and guided nature walks. It’s perfect for travelers seeking luxury along with active outdoor experiences."
    },
    {
      "name": "Nagpur Weekend Activity Resort",
      "description": "Ideal for a short weekend getaway, this resort offers a variety of outdoor activities such as cycling, kayaking, trekking, and team games. Guests can enjoy nature, adventure, and relaxation in a rejuvenating environment."
    },
    {
      "name": "Nagpur Booking Outdoor Activity Resort",
      "description": "Reserve your stay easily at Nagpur Booking Outdoor Activity Resort. Guests can choose from a variety of eco-friendly accommodations, participate in adventure activities, and enjoy guided tours, ensuring a memorable experience with hassle-free booking."
    },
    {
      "name": "Nagpur Team Outing Resort",
      "description": "Nagpur Team Outing Resort is perfect for corporate retreats and group outings. With team-building activities, obstacle courses, adventure sports, and scenic locations, it offers a productive yet fun experience for colleagues and friends."
    },
    {
      "name": "Nagpur One Day Activity Resort",
      "description": "For those seeking a quick outdoor getaway, Nagpur One Day Activity Resort offers one-day packages including nature walks, adventure activities, riverside games, and team exercises. Perfect for family outings, school trips, and corporate day trips."
    },
    {
      "name": "Nagpur Adventure Sports Resort",
      "description": "Nagpur Adventure Sports Resort is designed for thrill-seekers. Guests can indulge in activities like zip-lining, rock climbing, rappelling, kayaking, and cycling. Safety and professional guidance ensure an exhilarating experience for all ages."
    },
    {
      "name": "Nagpur Eco Outdoor Resort",
      "description": "Nagpur Eco Outdoor Resort emphasizes sustainable living alongside outdoor fun. Guests can enjoy eco-friendly accommodations, organic meals, guided nature trails, and adventure activities, all designed to minimize environmental impact while maximizing enjoyment."
    }
  ],
  "tableData": [
    ["- Resort in Nagpur District with Outdoor Activities", "- Nagpur Adventure Resort"],
    ["- Nagpur Nature Activities Resort", "- Nagpur Family Activity Resort"],
    ["- Nagpur Kids Friendly Activity Resort", "- Nagpur Jungle Adventure Resort"],
    ["- Nagpur Riverside Outdoor Resort", "- Nagpur Hill Activity Resort"],
    ["- Nagpur Luxury Activity Resort", "- Nagpur Weekend Activity Resort"],
    ["- Nagpur Booking Outdoor Activity Resort", "- Nagpur Team Outing Resort"],
    ["- Nagpur One Day Activity Resort", "- Nagpur Adventure Sports Resort"],
    ["- Nagpur Eco Outdoor Resort", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Adventure & Outdoor Resort in Nagpur District",
    "WhyChoosedescription": "Woodland Escape Resort offers an ideal setting for outdoor enthusiasts. Surrounded by lush greenery and forested landscapes, it provides a perfect mix of adventure, nature, and relaxation for families, couples, and groups."
  },
  {
    "WhyChooseheading": "Wide Range of Outdoor Activities",
    "WhyChoosedescription": "Guests can enjoy cycling, nature trails, birdwatching, pond-side games, and light adventure sports. The resort ensures activities are suitable for all ages and fitness levels, making it perfect for both energetic and leisurely visitors."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Accommodation",
    "WhyChoosedescription": "Woodland Escape Resort features well-designed rooms and cottages that provide comfort while keeping guests close to nature. Modern amenities combined with forest views make every stay enjoyable and refreshing."
  },
  {
    "WhyChooseheading": "Family-Friendly and Safe Environment",
    "WhyChoosedescription": "The resort is designed with families in mind, offering secure outdoor spaces, shaded sit-outs, and monitored activity zones. Children and adults can enjoy outdoor adventures safely and freely."
  },
  {
    "WhyChooseheading": "Scenic Trails and Nature Walks",
    "WhyChoosedescription": "Nature enthusiasts can explore scenic walking trails that meander through lush greenery. These walks allow guests to relax, observe wildlife, and connect with the natural surroundings."
  },
  {
    "WhyChooseheading": "Delicious Meals and Refreshments",
    "WhyChoosedescription": "After a day of outdoor fun, guests can enjoy freshly prepared meals, snacks, and beverages. The resort ensures that your energy is replenished and your stay is both enjoyable and satisfying."
  },
  {
    "WhyChooseheading": "Convenient Location with Serene Ambience",
    "WhyChoosedescription": "Located within Nagpur District, Woodland Escape Resort offers easy accessibility while maintaining a peaceful, nature-filled environment. Guests can enjoy outdoor adventures without long travel times."
  }
]































  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a resort in Nagpur district with outdoor activities?",
    answer: "Woodland Escape Resort offers a stay immersed in nature with a variety of engaging outdoor activities, making it perfect for guests seeking both relaxation and adventure in Nagpur district."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur city?",
    answer: "The resort is located within a comfortable driving distance from Nagpur city, giving you easy access while being tucked away in nature for an activity‑rich stay."
  },
  {
    question: "What outdoor activities does Woodland Escape Resort offer?",
    answer: "At Woodland Escape Resort you’ll find outdoor games, nature trails, cycling around the property, open‑lawn play, and other fun‑filled active options designed to get you moving and enjoying the fresh air."
  },
  {
    question: "Is Woodland Escape Resort suitable for families or groups looking for outdoor activity options?",
    answer: "Yes! The resort is designed for families, friends and groups who want a mix of comfort and activity — safe outdoor spaces, fun for kids and adults alike, plus nature to explore."
  },
  {
    question: "Does the resort offer meals and services aligned with an activity‑filled stay?",
    answer: "Yes. Woodland Escape Resort provides freshly prepared meals, snacks and beverages, ensuring you’re well‑nourished and comfortable after enjoying outdoor activities."
  },
  {
    question: "How can we book Woodland Escape Resort for a resort stay with outdoor activities in Nagpur district?",
    answer: "You can book by calling or WhatsApp messaging the resort’s reservations team or by visiting the official website. Booking ahead is recommended, especially if your group wants specific activities or active time slots."
  }
];

const testimonials = [
  {
    name: "Mr. & Mrs. Patel, Nagpur",
    text: "Our stay at Woodland Escape Resort was fantastic! We did nature walks, played on the lawn, and really loved the outdoor activity setup. A great resort with outdoor fun in Nagpur district."
  },
  {
    name: "Ms. Anjali & Friends, Nagpur",
    text: "The outdoor activities at Woodland Escape Resort made our weekend memorable — we cycled, relaxed and had fun in nature. Highly recommended for those who want more than just a room!"
  }
];































      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];

const outdoorActivityResortSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Resort in Nagpur District with Outdoor Activities",
  "image": "https://woodlandescape.com/assets/images/nagpur-outdoor-resort.jpg",
  "description": "Experience adventure and nature at our Resort in Nagpur District with Outdoor Activities. Perfect for families, kids, couples, and team outings with jungle, riverside, and hill-based activities.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "40"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/nagpur-outdoor-activity-resort"
  }
};





  return (
    <div>
<Helmet>
  <title>Resort in Nagpur District with Outdoor Activities | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Enjoy adventure and nature at our Resort in Nagpur District with Outdoor Activities. Ideal for families, kids, couples, and team outings with jungle, riverside, and hill activities." 
  />
  <meta 
    name="keywords" 
    content="Resort in Nagpur District with Outdoor Activities, Nagpur Adventure Resort, Nagpur Nature Activities Resort, Nagpur Family Activity Resort, Nagpur Kids Friendly Activity Resort, Nagpur Jungle Adventure Resort, Nagpur Riverside Outdoor Resort, Nagpur Hill Activity Resort, Nagpur Luxury Activity Resort, Nagpur Weekend Activity Resort, Nagpur Booking Outdoor Activity Resort, Nagpur Team Outing Resort, Nagpur One Day Activity Resort, Nagpur Adventure Sports Resort, Nagpur Eco Outdoor Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(outdoorActivityResortSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/54.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Resortinnagpurdistrictwithoutdoor;